// extracted by mini-css-extract-plugin
export default {"cls1":"Banner-cls1___5368cd9dac8c86d830a","cls2":"Banner-cls2___dd14d8ce5bfebdcc02c Banner-cls1___5368cd9dac8c86d830a"};